import React, { Component } from "react";
import { Row, Col, Button, Alert, Form, Modal, ListGroup } from "react-bootstrap";
import "containers/common/List.css";
import ReactTable from "react-table";
import { API } from "aws-amplify";
import { PacmanLoader } from 'react-spinners';
import { css } from '@emotion/core';
import Moment from "moment";


export default class TitleDetailsList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            isLoading: true,
            filter: {},
            dataSet: "titleDetails",
            dataRecord: (['slmsale', 'slmlease'].includes(props.context)) ? "slmTitleDetails" : "titleDetails",
            dataSetPrimaryKey: "parcel_id",
            showAlert: false,
            errorMessage: "",
            savingNewRecord: false,
            stateCode: props.stateCode,
            copyInProgress: false,
            reactTablePage: 0,
            // stateCode: 'VIC' // TODO removeme debug
        };

        this.columns = [
            {
                id: 'parcel_id',
                Header: 'ID',
                maxWidth: 60,
                accessor: 'title_detail_id',
                isParsedField: false
            },
            {
                id: 'jurisdiction_id',
                Header: 'Parcel Description',
                accessor: 'jurisdiction_id',
                maxWidth: 200,
                // Cell: this.renderEditable,
                getProps: (state, rowInfo, column) => {
                    return {
                        style: {
                            background: rowInfo && column.id === 'jurisdiction_id' ? 'lavender' : null,
                        },
                    };
                },
                isParsedField: true
            },
            {
                id: 'block',
                Header: 'Block',
                accessor: 'block',
                maxWidth: 100,
                Cell: this.renderEditable,
                applicableStates: ['ACT', 'VIC'],
                isParsedField: true
            },
            {
                id: 'section',
                Header: 'Section',
                accessor: 'section',
                maxWidth: 100,
                Cell: this.renderEditable,
                applicableStates: ['ACT', 'NSW', 'VIC'],
                isParsedField: true
            },
            {
                id: 'portion',
                Header: 'Portion',
                accessor: 'portion',
                maxWidth: 100,
                Cell: this.renderEditable,
                applicableStates: ['VIC'],
                isParsedField: true
            },
            {
                id: 'crown_allotment_number',
                Header: 'Crown Allotment Number',
                accessor: 'crown_allotment_number',
                maxWidth: 100,
                Cell: this.renderEditable,
                applicableStates: ['VIC'],
                isParsedField: true
            },
            {
                id: 'lot_type',
                Header: 'Lot Type',
                accessor: 'lot_type',
                maxWidth: 100,
                Cell: this.renderEditable,
                applicableStates: ['SA'],
                isParsedField: true
            },
            {
                id: 'lot_number',
                Header: 'Lot Number',
                accessor: 'lot_number',
                maxWidth: 70,
                Cell: this.renderEditable,
                applicableStates: ['NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA'],
                isParsedField: true
            },
            {
                id: 'plan_prefix',
                Header: 'Plan Prefix',
                accessor: 'plan_prefix',
                maxWidth: 70,
                Cell: this.renderEditable,
                applicableStates: ['NSW', 'QLD', 'SA', 'VIC', 'WA'],
                isParsedField: true
            },
            {
                id: 'plan_number',
                Header: 'Plan Number',
                accessor: 'plan_number',
                maxWidth: 100,
                Cell: this.renderEditable,
                applicableStates: ['NSW', 'QLD', 'SA', 'TAS', 'VIC', 'WA'],
                isParsedField: true
            },
            {
                id: 'survey_plan',
                Header: 'Survey Plan',
                accessor: 'survey_plan',
                maxWidth: 100,
                Cell: this.renderEditable,
                applicableStates: ['NT'],
                isParsedField: true
            },
            {
                id: 'unit',
                Header: 'Unit',
                accessor: 'unit',
                maxWidth: 70,
                Cell: this.renderEditable,
                applicableStates: ['ACT', 'NT'],
                isParsedField: true
            },
            {
                id: 'district',
                Header: 'District',
                accessor: 'district',
                maxWidth: 100,
                Cell: this.renderEditable,
                applicableStates: ['ACT'],
                isParsedField: true
            },
            {
                id: 'division',
                Header: 'Divison',
                accessor: 'division',
                maxWidth: 100,
                Cell: this.renderEditable,
                applicableStates: ['ACT'],
                isParsedField: true
            },
            {
                id: 'location_code',
                Header: 'Location Code',
                accessor: 'location_code',
                maxWidth: 100,
                Cell: this.renderEditable,
                applicableStates: ['NT'],
                isParsedField: true
            },
            {
                id: 'parish_code',
                Header: 'Parish Code',
                accessor: 'parish_code',
                maxWidth: 100,
                Cell: this.renderEditable,
                applicableStates: ['VIC'],
                isParsedField: true
            },
            // {
            //     id: 'parish',
            //     Header: 'Parish',
            //     accessor: 'parish',
            //     maxWidth: 200,
            //     Cell: this.renderEditable,
            //     applicableStates: ['VIC']
            // },
            {
                id: 'state_code',
                Header: 'State Code',
                accessor: 'state_code',
                maxWidth: 70,
                // Cell: this.renderEditable,
                isParsedField: false
            },
            // {
            //     id: 'land_area',
            //     Header: 'Land Area',
            //     accessor: 'land_area',
            //     maxWidth: 100,
            //     Cell: this.renderEditable,
            //     isParsedField: false
            // },
            {
                id: 'geometry',
                Header: 'Geometry',
                accessor: 'geometry',
                Cell: this.renderEditable,
                maxWidth: 200,
                style: { 'white-space': 'unset' },
                isParsedField: false
            },
            {
                id: 'created_date',
                Header: 'Created Date',
                accessor: d => {
                    if (d.created_date === null) {
                        return null;
                    }
                    return Moment(d.created_date).local().format("DD-MM-YYYY")
                },
                maxWidth: 100,
                isParsedField: false
            },
            {
                id: 'created_by',
                Header: 'Created By',
                accessor: 'created_by',
                maxWidth: 100,
                isParsedField: false
            },
            {
                id: 'last_edited_date',
                Header: 'Last Edited Date',
                accessor: d => {
                    if (d.last_edited_date === null) {
                        return null;
                    }
                    return Moment(d.last_edited_date).local().format('DD-MM-YYYY');
                },
                maxWidth: 100,
                isParsedField: false
            },
            {
                id: 'last_edited_by',
                Header: 'Last Edited By',
                accessor: 'last_edited_by',
                maxWidth: 100,
                isParsedField: false
            },
            {
                Header: '',
                accessor: 'parcel_id',
                maxWidth: 65,
                Cell: row => <Button type="button" size="sm" variant="danger" onClick={(e) => this.handleDeleteRecord(row, e)}>Delete</Button>,
                isParsedField: false
            },
            {
                id: 'copyButton',
                Header: '',
                accessor: 'property_id',
                maxWidth: 65,
                Cell: this.renderEditable, //row => <div><Button type="button" size="sm" variant="primary" onClick={(e) => this.handleCopyRecord(row,e)}>Copy</Button></div>
                isParsedField: false
            }
        ];

        this.handleDeleteRecord = this.handleDeleteRecord.bind(this);
    }

    async componentDidMount() {
        this.setState({ isLoading: true });

        if (!this.props.isAuthenticated) { // if false
            return;
        }

        this.setState({ isLoading: false });
    }

    componentWillUnmount() {
        this.setState({ addresses: [] });
    }

    async handleDataSave(data) {
        try {
            if (!data.state_code) {
                data.state_code = this.state.stateCode;
            }

            return await this.props.saveRecord(data, this.state.dataRecord, this.state.dataSetPrimaryKey);
        } catch (e) {
            console.error('handleDataSave() exception:', e);
            alert("Error saving");
        }
    }

    handleDeleteRecord = async (cellInfo, event) => {
        event.preventDefault();

        console.log("delete title details");

        let data = [...this.props.data];
        var r = window.confirm("Are you sure you want to delete this record?");

        if (r === true) {
            console.log(cellInfo);

            data[cellInfo.index].archived_date = new Date();

            if (!data[cellInfo.index].parcel_id) {
                data.splice(cellInfo.index, 1);
                this.props.updateTableState(data, this.state.dataSet);
                return;
            }

            await this.handleDataSave(data[cellInfo.index]).then((result) => {
                data.splice(cellInfo.index, 1);
                this.props.updateTableState(data, this.state.dataSet);
            });
        };
    };

    handleInputChange = (cellInfo, event) => {
        console.log(typeof (event.target.value));

        let data = [...this.props.data];

        data[cellInfo.index][cellInfo.column.id] = event.target.value;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };

    isTitleDetailsValid_ACT(titleDetails) {
        if (!/^[A-Z]{4}$/.test(titleDetails.district)) {
            return [false, 'District not 4 uppercase letters'];
        }

        if (!/^[A-Z]{4}$/.test(titleDetails.division)) {
            return [false, 'Division not 4 uppercase letters'];
        }

        if (!/^\d{1,3}$/.test(titleDetails.section)) {
            return [false, 'Section not 1-3 digits'];
        }

        if (!/^\d{1,4}$/.test(titleDetails.block)) {
            return [false, 'Block not 1-4 digits'];
        }

        if (titleDetails.unit && !/^\d{1,3}$/.test(titleDetails.unit)) {
            return [false, 'Unit not 1-3 digits'];
        }

        return [true, null];
    }

    isTitleDetailsValid_NSW(titleDetails) {
        if (titleDetails.lot_number && !/^[A-Z\d]+$/.test(titleDetails.lot_number)) {
            return [false, 'Lot Number not alphanumeric'];
        }

        if (titleDetails.section && !/^[A-Z\d]+$/.test(titleDetails.section)) {
            return [false, 'Section not alphanumeric'];
        }

        if (titleDetails.plan_prefix && !/^[A-Z]{1,2}$/.test(titleDetails.plan_prefix)) {
            return [false, 'Plan Prefix not 1-2 uppercase letters'];
        }

        if (!/^\d+$/.test(titleDetails.plan_number)) {
            return [false, 'Plan number not numeric'];
        }

        return [true, null];
    }

    isTitleDetailsValid_NT(titleDetails) {
        if (!/^\d{3}$/.test(titleDetails.location_code)) {
            return [false, 'Location Code not 3 digits'];
        }

        if (titleDetails.lot_number && !/^[A-Z\d]+$/.test(titleDetails.lot_number)) {
            return [false, 'Lot Number not alphanumeric'];
        }

        if (titleDetails.survey_plan && !/^[A-Z\d]+ *[A-Z\/\d]+$/.test(titleDetails.survey_plan)) {
            return [false, 'Survey Plan not alphanumeric with (optional) forward-slashes'];
        }

        if (titleDetails.unit && !/^\d+$/.test(titleDetails.unit)) {
            return [false, 'Unit not numeric'];
        }

        return [true, null];
    }

    isTitleDetailsValid_QLD(titleDetails) {
        if (titleDetails.lot_number && !/^[A-Z\d]+$/.test(titleDetails.lot_number)) {
            return [false, 'Lot Number not alphanumeric'];
        }

        if (!/^[A-Z]{1,3}$/.test(titleDetails.plan_prefix)) {
            return [false, 'Plan Prefix not 1-3 uppercase letters'];
        }

        if (!/^\d+$/.test(titleDetails.plan_number)) {
            return [false, 'Plan Number not numeric'];
        }

        return [true, null];
    }

    isTitleDetailsValid_SA(titleDetails) {
        // if (!/^[A-Z]{1,2}$/.test(titleDetails.lot_type)) {
        //     return [false, 'Lot Type not 1-2 uppercase letters'];
        // }

        if (titleDetails.lot_number && !/^[A-Z\d]+$/.test(titleDetails.lot_number)) {
            return [false, 'Lot Number not alphanumeric'];
        }

        if (!titleDetails.plan_prefix) {
            return [false, 'Plan Prefix must be set'];
        }

        if (!titleDetails.plan_number) {
            return [false, 'Plan Number must be set'];
        }

        return [true, null];
    }

    isTitleDetailsValid_TAS(titleDetails) {
        if (titleDetails.lot_number && !/^\d+$/.test(titleDetails.lot_number)) {
            return [false, 'Lot Number not numeric'];
        }

        if (!/^\d+$/.test(titleDetails.plan_number)) {
            return [false, 'Plan Number not numeric'];
        }

        return [true, null];
    }

    isTitleDetailsValid_VIC(titleDetails) {
        const atLeastOneOtherAttributeSet = (titleDetails.crown_allotment_number || titleDetails.section || titleDetails.portion || titleDetails.block);

        // if ((titleDetails.lot_number && !titleDetails.plan_prefix) || (!titleDetails.lot_number && titleDetails.plan_prefix)) {
        //     return [false, 'Lot Number and Plan Prefix must be set together'];
        // }

        if ((titleDetails.parish_code && !atLeastOneOtherAttributeSet) || (!titleDetails.parish_code && atLeastOneOtherAttributeSet)) {
            return [false, 'Parish Code and (Crown Allotment Number or Section or Portion or Block) must be set together'];
        }

        // if (!(titleDetails.lot_number && titleDetails.plan_prefix) && !(titleDetails.parish_code && atLeastOneOtherAttributeSet)) {
        //     return [false, 'Lot Number and Plan Prefix must be set together, or Parish Code and (Crown Allotment Number or Section or Portion or Block) must be set together'];
        // }

        if (titleDetails.lot_number && !/^[A-Z\d]+$/.test(titleDetails.lot_number)) {
            return [false, 'Lot Number not alphanumeric'];
        }

        if (titleDetails.plan_prefix && !/^[A-Z]{2}$/.test(titleDetails.plan_prefix)) {
            return [false, 'Plan Prefix not 2 uppercase letters'];
        }

        if (titleDetails.plan_number && !/^[A-Z\d]+$/.test(titleDetails.plan_number)) {
            return [false, 'Plan Number not alphanumeric'];
        }

        if (titleDetails.crown_allotment_number && !/^[A-Z\d]+$/.test(titleDetails.crown_allotment_number)) {
            return [false, 'Crown Allotment Number not alphanumeric'];
        }

        if (titleDetails.section && !/^[A-Z\d]+$/.test(titleDetails.section)) {
            return [false, 'Section not alphanumeric'];
        }

        if (titleDetails.block && !/^[A-Z\d]+$/.test(titleDetails.block)) {
            return [false, 'Block not alphanumeric'];
        }

        if (titleDetails.portion && !/^[A-Z\d]+$/.test(titleDetails.portion)) {
            return [false, 'Portion not alphanumeric'];
        }

        if (titleDetails.parish_code && !/^\d{4}$/.test(titleDetails.parish_code)) {
            return [false, 'Parish Code not 3 digits'];
        }

        return [true, null];
    }

    isTitleDetailsValid_WA(titleDetails) {
        if (titleDetails.lot_type && !/^[A-Z]+$/.test(titleDetails.lot_type)) {
            return [false, 'Lot Type not uppercase letters'];
        }

        if (titleDetails.lot_number && !/^[A-Z\d]+$/.test(titleDetails.lot_number)) {
            return [false, 'Lot Number not alphanumeric'];
        }

        if (!/^[A-Z]{1}$/.test(titleDetails.plan_prefix)) {
            return [false, 'Plan Prefix not 1 uppercase letter'];
        }

        if (!/^\d+$/.test(titleDetails.plan_number)) {
            return [false, 'Plan Number not numeric'];
        }

        return [true, null];
    }

    onlyParcelDescriptionSet = (parcel) => {
        const otherFields = this.columns.filter(c => c.isParsedField && c.id !== 'jurisdiction_id').map(c => c.id);
        let noOtherFieldsSet = Object.entries(parcel).filter(tuple => otherFields.includes(tuple[0])).every(tuple => !tuple[1]);

        return (!!parcel.jurisdiction_id && noOtherFieldsSet);
    };

    handleBlur = async (cellInfo, event) => {
        const titleDetail = cellInfo.original;
        console.log(`titleDetail: ${titleDetail}`);

        const validatorsForState = {
            'ACT': this.isTitleDetailsValid_ACT,
            'NSW': this.isTitleDetailsValid_NSW,
            'NT': this.isTitleDetailsValid_NT,
            'QLD': this.isTitleDetailsValid_QLD,
            'SA': this.isTitleDetailsValid_SA,
            'TAS': this.isTitleDetailsValid_TAS,
            'VIC': this.isTitleDetailsValid_VIC,
            'WA': this.isTitleDetailsValid_WA
        }
        const validator = validatorsForState[this.state.stateCode];

        if (validator) {
            const [validationResult, validationMessage] = validator(titleDetail);

            // If they're setting Parcel Description first then the other fields may be parsed out automatically,
            // so no need to do validation
            if (!this.onlyParcelDescriptionSet(titleDetail) && validationResult === false) {

                let message = `Parcel #${titleDetail.parcel_id} invalid and was NOT saved:\n${validationMessage}`;
                if (!titleDetail.parcel_id) {
                    message = `New parcel invalid and was NOT saved:\n${validationMessage}`;
                }

                await this.setState({ showAlert: true, errorMessage: message });
                return;
            }

            if (validationResult === true) {
                // If this edit is not on Parcel Description then it should be re-generated based on the other fields
                // Setting it to null tells the parser to do this
                if (cellInfo.column.id !== 'jurisdiction_id') {
                    titleDetail.jurisdiction_id = null;
                }

                await this.setState({ showAlert: false, errorMessage: null });
                await this.handleSave(titleDetail);
                await this.refetchData();
            }
        }


    };

    refetchData = async () => {
        // It's necessary to pull the data back again,
        // in case the sproc ran parsing on the Jurisdiction ID field.
        // -> user gets the populated fields immediately for confirmation.
        const newDataSet = await this.props.dataFetch();
        this.setState({ data: newDataSet });
    };

    handleSave = async (titleDetail) => {
        // Save unnecessary API calls if the record wasn't modified
        if (!titleDetail.hasOwnProperty('modified') || titleDetail.modified === false) {
            return;
        }

        const response = await this.handleDataSave(titleDetail);

        if (response.result !== true) {
            this.setState({ errorMessage: response.error_message });
            this.setState({ showAlert: true });

            return;
        }

        titleDetail.new_record = false;
        titleDetail[this.state.dataSetPrimaryKey] = response.id;
    }

    addRecord = async event => {
        let data = [...this.props.data];
        let foreign_key = { key: 'property_id', value: this.props.filter.propertyid }

        if (this.props.context === 'slmsale') {
            foreign_key = { key: 'sale_id', value: this.props.filter.saleid }
        } else if (this.props.context === 'slmlease') {
            foreign_key = { key: 'lease_id', value: this.props.filter.leaseid }
        }

        await this.setState({ reactTablePage: 0 });

        data.unshift({
            // parcel_id: null,
            [foreign_key.key]: foreign_key.value,
            note_data: '', // TODO move this
            jurisdiction_id: null,
            block: null,
            section: null,
            portion: null,
            crown_allotment_number: null,
            lot_type: null,
            lot_number: null,
            plan_prefix: null,
            plan_number: null,
            survey_plan: null,
            unit: null,
            district: null,
            division: null,
            location_code: null,
            parish_code: null,
            parish: null,
            state_code: null,
            land_area: null,
            created_date: null,
            created_by: this.props.user,
            last_edited_date: null,
            last_edited_by: null,
            archived_date: null,
            geometry: null,

            new_record: true
        });

        this.props.updateTableState(data, this.state.dataSet);
    }


    handleCopyRecord = async (cellInfo, event) => {
        console.log("handleCopyRecord()", cellInfo, event);
        event.preventDefault();

        let disclaimer = (this.state.stateCode !== 'ACT') ? '(Lot Number will be incremented with each copy.)' : '';
        let promptMessage = `How many copies do you want to create? ${disclaimer}`;
        const numCopies = parseInt(window.prompt(promptMessage));
        if (!numCopies) {
            return;
        }

        await this.setState({ copyInProgress: true });

        const titleDetails = cellInfo.original;
        let copies = [];

        for (let i = 0; i < numCopies; i++) {
            let copy = { ...titleDetails };

            copy.parcel_id = null;
            copy.jurisdiction_id = null;
            copies.geometry = null;
            copy.modified = true;
            copy.new_record = true;
            copy.created_by = this.props.user;

            // Non-ACT behavour: increment Lot Number
            if (this.state.stateCode !== 'ACT' && parseInt(copy.lot_number)) {
                copy.lot_number = (parseInt(copy.lot_number) + i + 1).toString();
            }

            copies.push(copy);
        }

        try {
            let url = `/properties/${titleDetails.property_id}/parcels_bulk/${titleDetails.parcel_id}`;
            if (this.props.context === 'slmsale') {
                url = `/slmsales/${titleDetails.sale_id}/parcels_bulk/${titleDetails.parcel_i}`;
            } else if (this.props.context === 'slmlease') {
                url = `/slmleases/${titleDetails.lease_id}/parcels_bulk/${titleDetails.parcel_i}`;
            }

            const response = await API.post('colin', url, { body: copies });

            if (response.result === false) {
                alert('Copying failed.');
                console.error('handleCopyRecord() call to /parcels_bulk failed:', response.error_message);
                return;
            }

            await this.refetchData();
        } catch (e) {
            console.error('handleCopyRecord() call to /parcels_bulk exceptioned:', e);
        } finally {
            await this.setState({ copyInProgress: false });
        }
    };

    renderEditable = cellInfo => {
        const cellValue = this.props.data[cellInfo.index][cellInfo.column.id];
        const trimmedCellValue = cellValue ? cellValue.trim() : "";

        if (cellInfo.column.id === "copyButton") {
            return (
                <Button type="button" size="sm" variant="primary" onClick={(e) => this.handleCopyRecord(cellInfo, e)}>Copy</Button>
            )
        }

        if (cellInfo.column.id.indexOf(["geometry"]) >= 0) {
            return (
                <Form.Control
                    onChange={(e) => {
                        const trimmedValue = e.target.value.trim();
                        this.handleInputChange(cellInfo, { target: { value: trimmedValue } });
                    }}
                    onBlur={(e) => {
                        const trimmedValue = e.target.value.trim();
                        this.handleSave(cellInfo, { target: { value: trimmedValue } });
                    }}
                    type="text"
                    as="textarea"
                    rows="2"
                    className="no-border form-control"
                    value={trimmedCellValue}
                    disabled

                />
            );
        }

        return (
            <input
                onChange={(e) => {
                    const trimmedValue = e.target.value.trim();
                    this.handleInputChange(cellInfo, { target: { value: trimmedValue } });
                }}
                onBlur={(e) => {
                    const trimmedValue = e.target.value.trim();
                    this.handleBlur(cellInfo, { target: { value: trimmedValue } });
                }}
                type="text"
                className="no-border form-control"
                style={{ backgroundColor: (cellInfo.column.id === 'jurisdiction_id') ? 'lavender' : null }}
                value={trimmedCellValue}
            />
        )
    }

    renderTable(data) {
        if (this.state.copyInProgress) {
            return (
                <div className="outer-div">
                    <div className='sweet-loading inner-div' >
                        <PacmanLoader
                            css={css`
                            display: block;
                            margin: 0 auto;
                            border-color: red`}
                            sizeUnit={"px"}
                            size={20}
                            color={'#e03c31'}
                            loading={this.state.copyInProgress}
                        />
                    </div>
                </div>
            );
        }

        if (!data) {
            return null
        } else {
            return (
                <ReactTable
                    data={data}
                    columns={this.columns.filter(c => c.applicableStates == null || c.applicableStates.includes(this.state.stateCode))}
                    defaultPageSize={10}
                    sortable={false}
                    page={this.state.reactTablePage}
                    onPageChange={reactTablePage => this.setState({ reactTablePage })}
                />
            )
        }
    }

    // refreshData(data, listAmount) {
    //     if (!data) {
    //         return null
    //     } else {
    //         const state = this.state.stateCode;
    //         let dataSorted = [...data];
    //         if (['NSW', 'QLD', 'SA', 'VIC', 'WA'].includes(state)) {
    //             dataSorted.sort((a, b) => {
    //                 return a.plan_number - b.plan_number || a.lot_number - b.lot_number;
    //             });
    //         } else if (['ACT'].includes(state)) {
    //             dataSorted.sort((a, b) => {
    //                 return a.block - b.block || a.section - b.section;
    //             });
    //         }
    //     }
    // }

    renderList(data, listAmount) {
        if (!data) {
            return null
        }
        else {
            const state = this.state.stateCode;
            let dataSorted = [...data];

            if (['NSW', 'QLD', 'SA', 'VIC', 'WA'].includes(state)) {
                dataSorted.sort((a, b) => {
                    return a.plan_number - b.plan_number || a.lot_number - b.lot_number;
                });
            } else if (['ACT'].includes(state)) {
                dataSorted.sort((a, b) => {
                    return a.block - b.block || a.section - b.section;
                });
            }

            let amt = 0

            if (listAmount) {
                amt = dataSorted.slice(0, parseInt(listAmount));
            } else {
                amt = dataSorted.slice(0, 5);
            }

            const latest = amt

            return [{}].concat(latest).map(
                (d, i) =>
                    i !== 0
                        ?
                        <ListGroup.Item key={i} as="a" header={d.jurisdiction_id}>
                            {d.jurisdiction_id}
                        </ListGroup.Item>
                        : ""
            );
        }
    }

    async deleteAll(event) {
        if ((this.props.data||[]).length === 0) {
            return;
        }

        const confirm = window.confirm('Are you sure you want to delete all Parcels?');

        if (!confirm) {
            return;
        }else{
            let data = [...this.props.data];
        
            for (let i = data.length - 1; i >= 0; i--){
                console.log('Processing item at index ${i}', data[i]);
                // Add archived date to each record
                data[i].archived_date = new Date();
    
               // If the item doesn't have a parcel_id, delete it directly
               if (!data[i].parcel_id) {
                data.splice(i, 1);  // Remove item from the array
                this.props.updateTableState(data, this.state.dataSet);  // Update the table state after deletion
                continue;  // Move to the next item
                }
                // If the item has a parcel_id, save it before deleting
                try {
                    await this.handleDataSave(data[i]);
                    data.splice(i, 1);  // Remove item after saving
                    this.props.updateTableState(data, this.state.dataSet);  // Update the table state after deletion
                } catch (error) {
                    console.error('Error saving item at index ${i}', error);
                }
            }
        }
    }

    renderComponent() {
        return (
            <div className="titleDetails">
                <Modal show={this.state.showAlert && this.props.data.length >= 1 && this.props.data[this.props.data.length - 1].title_detail_id} onHide={(e) => { this.setState({ showAlert: !this.state.showAlert }) }} centered >
                    <Modal.Header closeButton> <Modal.Title>Uh Oh!</Modal.Title></Modal.Header>
                    <Modal.Body > <Alert variant="danger"  >{this.state.errorMessage}</Alert> </Modal.Body>
                </Modal>
                {this.state.showAlert && this.props.data.length >= 1 && !this.props.data[this.props.data.length - 1].title_detail_id &&
                    <Alert variant="danger">{this.state.errorMessage}</Alert>
                }
                {this.props.controlType === "table" && <Row className="show-Container">
                    <Col className="text-right" >
                        {!this.state.copyInProgress &&
                            <div>
                                {/* <Button variant="secondary" size="sm" onClick={this.refreshData(this.props.data, this.props.listAmount)}>Refresh Sort</Button>&nbsp; */}
                                <Button variant="primary" size="sm" onClick={this.addRecord}>Add</Button>&nbsp;
                                <Button type="button" size="sm" variant="danger" onClick={(e) => this.deleteAll(e)}>Delete All</Button> 
                            </div>
                        }
                    </Col>
                </Row>}
                <Row className="show-Container">
                    <Col sm={12} md={12} lg={12}>
                        {!this.state.isLoading && this.props.controlType === "table" ? this.renderTable(this.props.data) : this.renderList(this.props.data, this.props.listAmount)}
                    </Col>
                </Row>
            </div>
        );
    }

    render() {
        if (!this.props.data) {
            return null
        } else {
            return (
                <div className="AddressSection">
                    {this.props.isAuthenticated ? this.renderComponent() : console.log("error)")}
                </div>
            );
        }
    }
}
